import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useColorService from '../../../app/services/hooks/useColorService';

interface Props {
    colorId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ColorSwitchChange = ({ colorId, checkValue, callbackSuccess }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeColor } = useColorService();

    useEffect(() => {
        setChecked(checkValue);
    }, [checkValue]);

    const active = (value: boolean) => {
        setChecked(value);
        activeColor(colorId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={colorId} callback={active} />;
};

export default ColorSwitchChange;
